import { render, staticRenderFns } from "./StockValue.vue?vue&type=template&id=8a5c6964&scoped=true&"
import script from "./StockValue.vue?vue&type=script&lang=js&"
export * from "./StockValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5c6964",
  null
  
)

export default component.exports